import React from "react";

export const isEDMode =
  typeof window !== "undefined"
    ? window.location.href.indexOf("ed=1") > 0
    : false;

export const getUrlParameter = (param) => {
  param = param.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + param + "=([^&#]*)");
  const results = regex.exec(window.location.search);

  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

/**
 * Creates a debounced function that delays invoking the provided function
 * until after the specified delay has elapsed.
 *
 * IMPORTANT: To ensure proper timeout closure, the debounced function should be
 * declared outside of any component or function where it will be used.
 *
 * ✅ CORRECT USAGE:
 * const debouncedFunction = debounce((value) => {
 *   // do something with value
 * }, 300);
 * window.addEventListener("scroll", debouncedFunction);
 *
 * ❌ INCORRECT USAGE (Don't do this):
 * window.addEventListener("scroll", debounce(() => {
 *   // code
 * }, 200));
 *
 * @param {Function} func - The function to debounce
 * @param {number} delay - The delay in milliseconds
 * @returns {Function} The debounced function
 */
export const debounce = (func, delay) => {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
};

export const extractTextFromElement = (element) => {
  const replaceNbsp = (str) => str.replace(/\u00A0/g, " ").replace(/&nbsp;/g, " ");

  if (typeof element === "string") return replaceNbsp(element);
  if (!React.isValidElement(element)) return "";

  const children = element.props?.children;
  if (!children) return "";

  if (Array.isArray(children)) {
    return replaceNbsp(children.map(extractTextFromElement).join(""));
  }

  return replaceNbsp(extractTextFromElement(children));
};


const uuidv4 = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
  );
};

export const getUuid = () => {
  // Check if the uuid is already in local storage
  if (typeof window !== "undefined") {
    const uuid = localStorage.getItem("uuid");
    if (uuid) {
      return uuid;
    }

    // if not, generate a new uuid
    const uuid_v4 = uuidv4();
    // save the uuid to local storage
    localStorage.setItem("uuid", uuid_v4);
    return uuid_v4;
  }
};


export const scrollToSection = (selector, offset = 0) => {
  if (typeof window !== "undefined") {
    const el = document.querySelector(selector);
    if (el) {
      const elementPosition =
        el.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  }
};